// gate-approve-command-hint.ts — 06k C12 (F-53, run 11): hint dừng ở gate/câu hỏi
// in lệnh CLI TRƯỚC (Mattermost có thể tắt), cú pháp Mattermost trong ngoặc.
// Một nguồn cho mọi chỗ in hint (DRY) — không dấu chấm cuối, nơi gọi tự nối.

export function approveHint(gate: string, requestId = "<request-id>"): string {
  return (
    `Duyệt bằng \`avatar autopilot approve ${gate} --request ${requestId}\` ` +
    `(Mattermost: \`@avatar approve ${gate} ${requestId}\`)`
  );
}

export function answerHint(): string {
  return (
    "Trả lời bằng `avatar autopilot answer --question <question-id> --text <giá trị>` " +
    "(Mattermost: `@avatar answer <question-id>: <giá trị>`)"
  );
}
